export default "__VITE_ASSET__CyA4nc$E__"